export const isApplePaySupported = () =>
    window.ApplePaySession?.supportsVersion(3) &&
    window.ApplePaySession?.canMakePayments();

export const isApplePayCardActive = async () =>
    isApplePaySupported() &&
    (await window.ApplePaySession?.canMakePaymentsWithActiveCard(
        'merchant.com.eventbrite.attendee',
    ));
